import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  LinearProgress
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { secondarySc50 } from 'common/colors';
import closeWebview from 'helpers/closeWebview';
import { PATHNAME_EXIT } from 'common/constants';
import { connect } from 'react-redux';
import * as actions from '../../store/actions'

const styles = theme => ({
  appbar: {
    boxShadow: 'none',
    maxWidth: '500px',
    margin: '0 auto',
    right: 'auto'
  },
  appbarTransparent: {
    boxShadow: 'none',
    maxWidth: '500px',
    margin: '0 auto',
    right: 'auto',
    backgroundColor: 'transparent'
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.text.primary
  },
  menuButtonTransparant: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    color: 'white',
    fontFamily: 'Lato',
    lineHeight: '24px'
  },
  toolbar: {
    width: '100%'
  },
  progressiveBar: {
    borderRadius: 0,
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: secondarySc50
    }
  }
});

const MainAppBar = ({
  classes,
  title = '',
  icon,
  onClick,
  variant,
  titleAlign,
  color,
  type,
  progressive,
  history,
  error,
  resetError
}) => {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    switch (progressive) {
      case 'persaved':
        setPercent(33.3);
        break;
      case 'paysaved':
        setPercent(66.6);
        break;
      case 'consaved':
        setPercent(100);
        break;
      default:
        setPercent(0);
        break;
    }
  }, [progressive]);

  const onBack = () => {
    if(error === 'incorrect_otp' || error === 'otp_temporary_locked'){
      resetError();
    }
    const currentPath = window.location.pathname;

    if (PATHNAME_EXIT.includes(currentPath)) {
      closeWebview(history);
    } else if (window.history.length > 1) {
      history.goBack();
    } else {
      closeWebview(history);
    }
  };

  return (
    <>
      <AppBar
        className={
          variant === 'transparent' ? classes.appbarTransparent : classes.appbar
        }
      >
        <Toolbar className={classes.toolbar}>
          {icon !== 'hide' && (
            <IconButton
              aria-label="menu"
              className={
                variant === 'transparent'
                  ? classes.menuButton
                  : classes.menuButtonTransparant
              }
              color={variant === 'transparent' ? 'default' : 'inherit'}
              edge="start"
              onClick={onClick || onBack}
            >
              {icon}
            </IconButton>
          )}
          <Typography
            className={classes.title}
            style={{
              textAlign: titleAlign || 'center',
              color: color ? 'black' : 'white',
              paddingRight: '30'
            }}
            variant="h5"
          >
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      {type === 'form' ? (
        <div style={{ height: '10px', margin: '0 auto' }}>
          <LinearProgress
            className={classes.progressiveBar}
            value={percent}
            variant="determinate"
          />
        </div>
      ) : null}
    </>
  );
};

const mapStatesToProps = states => {
  return {
    error: states.auth.error
  };
};

MainAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.string,
  history: PropTypes.object,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  progressive: PropTypes.string,
  resetError: PropTypes.func,
  title: PropTypes.string,
  titleAlign: PropTypes.oneOf(['left', 'center']),
  variant: PropTypes.string
};

MainAppBar.defaultProps = {
  title: '',
  icon: <ArrowBackIcon />,
  titleAlign: 'left'
};

const mapDispatchToProps = dispatch => {
  return {
    resetError: () => dispatch(actions.setError(''))
  }
}

export default withStyles(styles)(connect(mapStatesToProps, mapDispatchToProps)(MainAppBar));
